import { Prospect } from 'crono-fe-common/types/prospect';
import { isComplete } from 'crono-fe-common/types/sequenceInstance';

//Ownership is deliberately not part of these checks: a manager can stop or
//resume the sequence of a contact they don't own, so the footer is what narrows
//the buckets down to the contacts the current user may act on
export const hasActiveSequence = (prospect: Prospect): boolean => {
  const { sequenceInstance } = prospect;

  return (
    !!sequenceInstance &&
    !isComplete(sequenceInstance) &&
    sequenceInstance.active
  );
};

//A stopped sequence keeps the company it was created on, so a contact moved to
//another one cannot be resumed: the backend reopens an instance only when it
//still matches the contact's company, and offering it here left the contact
//silently skipped by the resume
export const hasStoppedSequence = (prospect: Prospect): boolean => {
  const { sequenceInstance } = prospect;

  return (
    !!sequenceInstance &&
    !isComplete(sequenceInstance) &&
    !sequenceInstance.active &&
    sequenceInstance.accountId === prospect.accountId
  );
};
